export default __webpack_public_path__ + "5a3a6fec4694c4a26a93264495dc6e9e.svg";